// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2DEJZ","title":"AfterBackImages_title__2-8sg","images":"AfterBackImages_images__283Jw"};